export const engagementCampaignEmailClickDailyStatsCampaignId =
  "/engagement/campaign_email_click_daily_stats/:campaign_id";
